import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Optional,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { NewButtonComponent } from "@app/shared/components/new-components/new-button/new-button.component";
import { EBtnAttributeMatType } from "@app/shared/components/new-components/new-button/types/attribute-mat.type";
import { EBtnHierarchyType } from "@app/shared/components/new-components/new-button/types/hierarchy.type";
import { EBtnSizeType } from "@app/shared/components/new-components/new-button/types/size.type";
import { DashboardService } from "@app/views/pages/dashboard/services/dashboard.service";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { TranslateModule } from "@ngx-translate/core";
import { from, Subscription } from "rxjs";

@Component({
	selector: "tc-dialog-alert-update",
	imports: [NewButtonComponent, TranslateModule],
	templateUrl: "./dialog-alert-update.component.html",
	styleUrl: "./dialog-alert-update.component.scss",
	encapsulation: ViewEncapsulation.None,
})
export class DialogAlertUpdateComponent implements OnInit, OnDestroy {
	// Subscription
	updateSubscription: Subscription;

	// Output
	@Output() afterClosed = new EventEmitter<void | any>();

	// Input
	@Input() dataDialog: any;

	// string
	latestVersion: string;
	marketUrl: string;
	downloadAppUrl: string;

	// types
	attributeVariantsType = EBtnAttributeMatType;
	hierarchyType = EBtnHierarchyType;
	sizeType = EBtnSizeType;

	constructor(
		@Optional() private dialogRef: MatDialogRef<DialogAlertUpdateComponent>,
		private dashboardService: DashboardService
	) {}

	// =================================
	//#region   LIFE CYCLE HOOK
	// =================================

	ngOnInit(): void {
		const state = history.state;
		this.marketUrl = state?.marketUrl || "";
		this.latestVersion = state?.latestVersion || "";
	}

	ngOnDestroy(): void {
		this.updateSubscription?.unsubscribe();
	}
	//#endregion

	// ===============================
	//#region       PUBLIC
	// ===============================
	close(): void {
		if (this.dialogRef) {
			this.dialogRef.close();
		} else {
			let value = {
				closeDialog: true,
			};
			this.afterClosed.emit(value);
		}
	}

	updateNow(): void {
		// if (this.marketUrl) {
		//   await Browser.open({ url: this.marketUrl });
		// }
		this.updateSubscription = from(this.getAndroidAppLink()).subscribe();
	}

	private async getAndroidAppLink(): Promise<void> {
		try {
			const randomNumber = new Date().getTime();
			const url = `https://tc-static-public.topchnge.net/download/app/my.json?v=${randomNumber}`;

			const res = await fetch(url);
			const data = await res.json();
			const downloadUrl = data["androidLink"];

			if (!downloadUrl) {
				console.error("download link not found");
				return;
			}

			if (Capacitor.isNativePlatform()) {
				await Browser.addListener("browserFinished", () => {
					Browser.removeAllListeners();
				});
				await Browser.open({ url: downloadUrl });
			} else {
				window.open(downloadUrl, "_blank");
			}
		} catch (e) {
			console.error("error get download link:", e);
		}
	}

	//#endregion
	// =================================
	//#region         PRIVATE
	// =================================

	//#endregion
}
